import React from 'react'
import { change, show, store, update, success as changeSuccess } from '../../../store/actions/cupons.action'
import { CircularProgress, TextField, AppBar, Toolbar, IconButton, InputAdornment, Typography, Button } from '@material-ui/core'
import { FaSave } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FcCalendar } from "react-icons/fc";
import { useDispatch, useSelector } from 'react-redux'
import { changeScreenB } from '../../../store/actions/navigation.action'

export default function CuponsEdit(props) {
    const dispatch = useDispatch()
    const { promotion, error } = useSelector(state => state.cuponsReducer)
    const id = (props.uid) ? props.uid : null;
    const campaign_id = (props.campaign_id) ? props.campaign_id : null;

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(dateInit);
    const [dateFinal, setDateFinal] = React.useState(dateEnd);

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            setLoading(false)
        }
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(promotion))
        } else {
            dispatch(store({
                'campaign_id' : campaign_id,
                'title' : promotion.title,
                'amount' : promotion.amount,
                'created_at' : dateInitial,
                'expires_at' : dateFinal
            }))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Cupom' : 'Novo Cupom'}
                    </Typography>

                    <Button onClick={() => _save() } color="inherit" className="ms-auto">
                        <FaSave className="me-2" /> Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card p-3 mt-3 mb-2">
                        <label className="fw-bold label-custom"><FcCalendar size={20} className="me-2" />Validade</label>
                        
                        <div className="row mt-2">
                            <div className="col-6">
                                <div className="date">
                                    <label className="label-date">
                                        {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                        {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                    </label>
                                    <TextField
                                        id="datetime-local"
                                        label="Data Inicial"
                                        type="datetime-local"
                                        defaultValue={dateInitial}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onBlur={e => {
                                            if(e.target.value) {
                                                setDateInitial(e.target.value)
                                            } else {
                                                setDateInitial(dateInit)
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="date">
                                    <label className="label-date">
                                        {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                        {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                    </label>
                                    <TextField
                                        id="datetime-local"
                                        label="Data Final"
                                        type="datetime-local"
                                        defaultValue={dateFinal}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onBlur={e => {
                                            if(e.target.value) {
                                                setDateFinal(e.target.value)
                                            } else {
                                                setDateFinal(dateEnd)
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card card-body mt-3">
                        <div className="mb-3">
                            <label className="label-custom">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={promotion.title || ''}
                                placeholder="Ex: iPhone 15"
                                onChange={text => {
                                    dispatch(change({ title: text.target.value }))
                                    if (error.title && delete error.title);
                                }}
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom">Valor</label>
                            <TextField
                                error={(error.amount) && true}
                                name="money"
                                InputProps={{
                                    value: promotion.amount || '',
                                    onChange: text => {

                                        dispatch(change({ amount: text.target.value.replace(',', '.') }))
                                        if (error.amount) {
                                            delete error.amount
                                        }
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <strong>R$</strong>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {(error.amount) &&
                                <strong className="text-danger">{error.amount[0]}</strong>
                            }
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className="alert alert-success mt-3" role="alert">
                            <strong>VALOR:</strong> Compras acima do valor predefinido o cliente ganha um cupom. 
                        </div>
                        <div className="alert alert-warning mt-3" role="alert">
                            <strong>VALIDADE:</strong> Data inicial e data de termino que terá validade essa promoção.
                        </div>
                    </div> 
                </>
            }
        </div>
    )
}